/**
 * Custom hook for consistent slide-up animation variants
 * Used across multiple components for a unified animation experience
 *
 * @param {number} delay - Animation delay in seconds (default: 0)
 * @returns {Object} Framer Motion animation variants
 */
export const useSlideUpVariants = (delay = 0) => {
  return {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: delay,
        ease: [0.25, 0.46, 0.45, 0.94],
        opacity: {
          duration: 0.5,
          ease: 'easeOut',
        },
        y: {
          duration: 0.5,
          ease: [0.25, 0.46, 0.45, 0.94],
        },
      },
    },
  };
};
